<template>
	<b-circular-icon-button
		big
		:icon="iconName"
		:customBackgroundColors="bgColorClass"
		:customIconColors="iconColorClass"
		v-on="$listeners"
	/>
</template>

<script>
import BCircularIconButton from './CircularIconButton.vue';

export default {
	name: 'b-favorite-button',
	components: {
		BCircularIconButton
	},
	props: {
		/**
		 * Define se o botão estará no modo favoritar ou desfavoritar. Se true botão é exibido como favoritado
		 */
		isFavorite: {
			type: Boolean,
			required: true
		}
	},
	computed: {
		iconName() {
			if (this.isFavorite) return `favorite`;
			return `favorite-border`;
		},
		iconColorClass() {
			if (this.isFavorite) return `white-base`;
			return `red-base`;
		},
		bgColorClass() {
			if (this.isFavorite) return `bg-red-base`;
			return `bg-red-lighter-3`;
		}
	},
};
</script>

<docs>
    Botão para favoritar/desfavoritar

    ```js
    <b-favorite-button :isFavorite="true"></b-favorite-button>

    ```
</docs>
